export const COUNTRY_CODES = {
  GERMANY: 'DE',
  UNITED_ARAB_EMIRATES: 'AE',
  ARABIC: 'arabic', // Doing this because the prismic document has different Id for Arabic
};

export const replaceSpaceInString = (str = '', substitute = '') => str.replace(/\s/g, substitute);
